import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoadingScreen } from "Components";
import { CreateAction } from "./CreateAction";
import { authService } from "Service/Axios";
import { convertLinkObjectListToJoin } from "Utils";
import { DELETE_ADMIN_ACTION_URL, UPDATE_ADMIN_ACTION_URL } from "Constant/api";
import { useActionList } from "Constant/apiHooks";
import { COLOR_SETTINGS } from "Constant/constants";

export const Action = () => {
  const { t } = useTranslation();
  const { projectList } = useOutletContext();

  const [showCreateAction, setShowCreateAction] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);

  const {
    actionList,
    loading: actionLoading,
    fetchActionList,
  } = useActionList();

  // Toggle
  const toggleCreateAction = (action) => {
    if (action) {
      setSelectedAction(action);
    } else {
      setSelectedAction(null);
    }
    setShowCreateAction(!showCreateAction);
  };

  // Handle
  const onSaveAction = async (action, actionBackgroundColor) => {
    try {
      const payload = {
        gid: action.gid,
        global: action.global,
        projects: action.projects?.map((option) => option.gid),
        name: action.name,
        label: action.label,
        backgroundColor: actionBackgroundColor,
        show: action.show,
      };
      const response = await authService(
        UPDATE_ADMIN_ACTION_URL,
        "POST",
        payload
      );
      if (response.success) {
        toast.success(t("common.messages.notification.success.updateAction"));
      } else {
        toast.error(response.message);
      }
      fetchActionList();
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  const onDeleteAction = async (gid, projectId) => {
    try {
      const data = {
        gid,
        projectId,
      };
      const response = await authService(DELETE_ADMIN_ACTION_URL, "POST", data);
      if (response.success) {
        fetchActionList();
        toast.success(t("common.messages.notification.success.deleteAction"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <>
      <div className="actions">
        <div className="d-flex align-items-center mb-3">
          <h4 className="admin-sub-title">{t("common.button.actions")}</h4>
          <div className="ms-auto">
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => toggleCreateAction()}
            >
              <i className="bx bx-plus"></i> {t("common.button.createAction")}
            </button>
          </div>
        </div>
        <div className="table-container mb-4 max-h-700">
          <table className="table table-bordered">
            <thead className="table-light position-sticky top-0 z-20">
              <tr>
                <th>{t("common.label.actionName")}</th>
                <th>{t("common.label.projects")}</th>
                <th>{t("common.label.backgroundColor")}</th>
                <th className="text-center">{t("common.label.action")}</th>
              </tr>
            </thead>
            <tbody>
              {actionLoading ? (
                <tr className="loading-screen">
                  <td colSpan={5}>
                    <LoadingScreen />
                  </td>
                </tr>
              ) : (
                actionList &&
                actionList.length > 0 &&
                actionList.map((button) => (
                  <tr key={button.gid}>
                    <td>{button.name}</td>
                    <td>
                      {button.projects &&
                        convertLinkObjectListToJoin(button.projects)}
                    </td>
                    <td>
                      <ul className="color-list">
                        {COLOR_SETTINGS.map((color) => (
                          <li className="round" key={color}>
                            <input
                              type="radio"
                              name={`backgroundColor${button.gid}${color}`}
                              id={`backgroundColor${button.gid}${color}`}
                              value={color}
                              checked={button.backgroundColor === color}
                              onChange={(e) =>
                                onSaveAction(button, e.target.value)
                              }
                            />
                            <label
                              htmlFor={`backgroundColor${button.gid}${color}`}
                              style={{
                                backgroundColor: color,
                                borderColor: color,
                              }}
                            ></label>
                          </li>
                        ))}
                      </ul>
                    </td>
                    <td>
                      <>
                        <div className="d-flex justify-content-center align-items-center gap-1">
                          <button
                            type="button"
                            className="button edit btn btn-transparent px-1 text-green-500"
                            onClick={() => toggleCreateAction(button)}
                          >
                            <i className="bx bxs-pencil"></i>
                          </button>
                          <button
                            type="button"
                            className="button delete btn btn-transparent px-1 text-red-500"
                            onClick={() =>
                              onDeleteAction(button.gid, button.projectId)
                            }
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        </div>
                      </>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showCreateAction && (
        <CreateAction
          show={showCreateAction}
          selectedData={selectedAction}
          toggle={toggleCreateAction}
          fetchList={fetchActionList}
          projectList={projectList}
        />
      )}
    </>
  );
};
